import { Component, OnInit, ViewChild } from '@angular/core';
import { DataService } from '../../services/data.service';
import { BusinesLogicService } from '../../services/business-logic.service';
import { UtilsService } from '../../services/utils.service';
import { LoginComponent } from '../login/login.component';
import { CallComponent } from '../../actions/call/call.component';
import { AppComponent } from '../../app.component';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BusinessEventService } from '../../services/business-event.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  public isCallLoading: boolean = false;

  private destroy$ = new Subject();

  turn: object = null;
  selectedTurn: object = null;
  user: string = "";
  password: string = "";

  @ViewChild(LoginComponent)
  public loginComponent: LoginComponent;

  @ViewChild(CallComponent)
  public callComponent: CallComponent;

  @ViewChild(AppComponent)
  public appComponent: AppComponent;

  constructor(public _data: DataService,
    private _utils: UtilsService,
    private _bevent: BusinessEventService,
    private _blogic: BusinesLogicService) { }

  ngOnInit() {
    this._utils.initializeTooltip();
    this._updateTurn(this._data.turn);
    this._data.turnUpdate
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response: object) => {
          this._updateTurn(response);
        }
      );

    this._data.selectedTurnUpdate
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response: object) => {
          this._selectedUpdateTurn(response);
        }
      );
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /* Logout and close actual turn */
  public logout(): void {
    this._utils.localStorage("delete", "session");

    let params: object = {
      login: this._data.session["operator"],
      desk_id: this._data.session["desk"]
    };

    this._blogic.logout()
    .pipe(takeUntil(this.destroy$))
    .subscribe();

    window.location.reload();

    if (this._data.turn != null) {
      this._close();
    }
  }

  /* When the turn information change */
  private _updateTurn(turn: object): void {
    this.turn = this._data.turn;
  }

  /* Close current turn */
  private _close() {
    let params = {
      desk_id: this._data.session["desk"],
      status: "I",
      turn_id: this._data.turn["id"],
      ticket: this._data.turn["num"],
      label: this._data.turn["label"],
      queue_id: this._data.turn["queue_id"],
      session_id: this._data.session["session"],
      kind_id: this._data.session["category"],
      deskuser: this._data.session["username"],
      deskoperator: this._data.session["operator"]
    };

    this._blogic.deskNotify(params)
    .pipe(takeUntil(this.destroy$))
    .subscribe();
  }

  /* When the turn information change */
  private _selectedUpdateTurn(selectedTurn: object): void {
    this.selectedTurn = selectedTurn;
  }

  /* User grant configuration */
  public configurationGrant(): boolean {
    let grant: any = this._data.session["grant"];
    return grant.mesa.config;
  }

  public login(): void {
    this._bevent.close();

    let credentials: object = {
      desk_id: parseInt(this._data.session["desk"]),
      username: this.user,
      pwd: this.password
    };

    this.loginComponent.doLogin(credentials, false, false);
    this.user = "";
    this.password = "";
  }

  public callLoading(event) {
    this.isCallLoading = event;
  }

  shouldShowDeskId(): boolean {
    return this._data.json_config &&
      this._data.json_config.showdeskid === true;
  }

  shouldShowOfficeId(): boolean {
    return this._data.json_config &&
      this._data.json_config.showofficeid === true;
  }
}
